import ProposalState from "../constants/ProposalState";
import { Gig, GigProposal } from "../interfaces/Gig";

export const canEditProposal = (proposal?: Partial<GigProposal> | null) => {
  if (!proposal) return false;
  const state = proposal.proposalState;
  const notSelected = !proposal.selectedAt;
  const isEditableState =
    state === ProposalState.DRAFT || state === ProposalState.OPEN_BID;
  return Boolean(isEditableState && notSelected);
};

export const canEditGig = (gig?: Partial<Gig> | null) => {
  if (!gig) return false;
  const state = gig.gigState;
  const notSelected = !gig.selectedProposalId;
  const isEditableState =
    state === ProposalState.DRAFT ||
    state === ProposalState.NEW_GIG ||
    state === ProposalState.OPEN_BID;
  return Boolean(isEditableState && notSelected);
};
